import styled from 'styled-components';

const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default TableFooter;
